import React, { useState } from "react";
import "./AboutSection.css";
import { useTranslation } from "react-i18next";
import aboutFirstImg from "../../../../../assets/images/about-first-section.png";
import aboutSecoundImg from "../../../../../assets/images/about-secound-section.png";
import aboutSectionIcon1 from "../../../../../assets/icons/aboutSectionIcon1.svg";
import aboutSectionIcon2 from "../../../../../assets/icons/aboutSectionIcon2.svg";
import aboutSectionIcon3 from "../../../../../assets/icons/aboutSectionIcon3.svg";
import aboutSectionIcon4 from "../../../../../assets/icons/aboutSectionIcon4.svg";

function AboutSection() {
  const { t } = useTranslation("about");

  return (
    <>
      <section className="about-section about-first-section">
        <div className="container">
          <picture>
            <img src={aboutFirstImg} alt="" srcset="" />
          </picture>
          <div className="about-section-content">
            <h3>{t("aboutSection.aboutFirstSectionHeading")}</h3>
            <p>{t("aboutSection.aboutFirstSectionContent")}</p>
          </div>
        </div>
      </section>
      <section className="about-middle-section">
        <div className="container">
          <div className="about-card">
            <img src={aboutSectionIcon1} alt="" />
            <div>
              <h6>+754</h6>
              <p className="small">{t("aboutSection.middleSectionFirstItem")}</p>
            </div>
          </div>
          <div className="about-card">
            <img src={aboutSectionIcon2} alt="" />
            <div>
              <h6>+504</h6>
              <p className="small">{t("aboutSection.middleSectionSecoundItem")}</p>
            </div>
          </div>
          <div className="about-card">
            <img src={aboutSectionIcon3} alt="" />
            <div>
              <h6>+320</h6>
              <p className="small">{t("aboutSection.middleSectionThirdItem")}</p>
            </div>
          </div>
          <div className="about-card">
            <img src={aboutSectionIcon4} alt="" />
            <div>
              <h6>115</h6>
              <p className="small">{t("aboutSection.middleSectionFourthItem")}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="container">
          <div className="about-section-content">
            <h3>{t("aboutSection.aboutSecoundSectionHeading")}</h3>
            <p>{t("aboutSection.aboutSecoundSectionContent")}</p>
          </div>
          <picture>
            <img src={aboutSecoundImg} alt="" srcset="" />
          </picture>
        </div>
      </section>
    </>
  );
}

export default AboutSection;
